import { React /* StrictMode, lazy, Suspense */ } from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import './index.css';
import App from './App';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import PublicRoute from './Utils/PublicRoute';
import PrivateRoute from './Utils/PrivateRoute';
import Login from './components/Login';
import JoinUs from './components/JoinUs';
import HomeWebPage from './components/webPage/home';
import AboutUsWebPage from './components/webPage/aboutus';
import AboutUsHindiWebPage from './components/webPage/aboutushindi';
import ServicesWebPage from './components/webPage/services';
import ContactUsWebPage from './components/webPage/contactus';
import TermConditionWebPage from './components/webPage/term_condition';
import PrivacyPolicyWebPage from './components/webPage/privacypolicy';
import RefundPolicyWebPage from './components/webPage/refund_policy';
import PaymentPolicyWebPage from './components/webPage/paymentPolicy';
import DownloadWebPage from './components/webPage/download';
import Forget from './components/Forget';
import ForgetUserId from './components/ForgetUserId';
import KycDetails from './components/KycDetails';

import HomeWebPageSrpay1 from './components/webPage/srpay1/home';
import ServicesWebPageSrpay1 from './components/webPage/srpay1/services';
import BankingServices from './components/webPage/srpay1/bankingServices';
import BbpsService from './components/webPage/srpay1/bbpsService';
import TravelServices from './components/webPage/srpay1/travelServices';
import UtilityServices from './components/webPage/srpay1/utilityServices';
import { Modal } from "antd";

// ✅ Disable Right Click + Keyboard Shortcuts
const allowedHosts = [
  "localhost:3000",
  "srpay1.com",
  "dev.srpay1.com"
];

if (allowedHosts.includes(window.location.hostname)) {
  // Disable Right Click
  document.addEventListener("contextmenu", (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }, true);

  // Disable Keyboard Shortcuts
  document.addEventListener("keydown", (e) => {
    // F12
    if (e.key === "F12") {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C
    if (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) {
      e.preventDefault();
      return false;
    }
    // Ctrl+U (View Source)
    if (e.ctrlKey && e.key.toUpperCase() === "U") {
      e.preventDefault();
      return false;
    }
  }, true);
}

// Modal.config({
//     maskClosable: false,
//     keyboard: false
// });

const Routes = (
  <Router>
    <Switch>
      <PublicRoute exact path="/" component={(process.env.REACT_APP_SRPAY_LINK) ? HomeWebPageSrpay1 : HomeWebPage} />
      <PublicRoute exact path="/services" component={(process.env.REACT_APP_SRPAY_LINK) ? ServicesWebPageSrpay1 : ServicesWebPage} />
      <PublicRoute exact path="/banking-services" component={(process.env.REACT_APP_SRPAY_LINK) ? BankingServices : ""} />
      <PublicRoute exact path="/bbps-service" component={(process.env.REACT_APP_SRPAY_LINK) ? BbpsService : ""} />
      <PublicRoute exact path="/travel-services" component={(process.env.REACT_APP_SRPAY_LINK) ? TravelServices : ""} />
      <PublicRoute exact path="/utility-services" component={(process.env.REACT_APP_SRPAY_LINK) ? UtilityServices : ""} />
      <PublicRoute exact path="/aboutus" component={AboutUsWebPage} />
      <PublicRoute exact path="/aboutus-hindi" component={AboutUsHindiWebPage} />
      <PublicRoute exact path="/contact-us" component={ContactUsWebPage} />
      <PublicRoute exact path="/term-condition" component={TermConditionWebPage} />
      <PublicRoute exact path="/privacy-policy" component={PrivacyPolicyWebPage} />
      <PublicRoute exact path="/refund-policy" component={RefundPolicyWebPage} />
      <PublicRoute exact path="/payment-policy" component={PaymentPolicyWebPage} />
      <PublicRoute exact path="/download" component={DownloadWebPage} />
      <PublicRoute exact path="/login" component={Login} />
      <PublicRoute exact path="/joinus" component={JoinUs} />
      <PublicRoute exact path="/forget-password" component={Forget} />
      <PublicRoute exact path="/forget-userid" component={ForgetUserId} />
      <PrivateRoute exact path="/kyc-details" component={KycDetails} />
      <Route path="/" component={App} />
    </Switch>
  </Router>
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(Routes);

reportWebVitals();